import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { CommonModule } from '@angular/common';
import {ToastModule} from 'primeng/toast';
import {ThemeService} from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, InputTextModule, ButtonModule, MessageModule, FormsModule, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private themeService = inject(ThemeService);

  text = '';
  msg = '';

  ngOnInit() {
    // Initialize theme service to apply saved preference or system preference
    // The service constructor already handles this, but we ensure it's initialized
  }

  onClick() {
    this.msg = 'Welcome ' + this.text;
  }
}
